module.exports = __webpack_public_path__ + "saira-medium-webfont.0f1338e8d63a7027cd8d.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-medium-webfont.ttf
// module id = ../../../../../src/assets/fonts/saira-medium-webfont.ttf
// module chunks = styles